export const MenuIdHelpCenterManagement = 'HELP_CENTER_MANAGEMENT' as const;
